export default "__VITE_ASSET__DLcM8_n1__"